interface QueryMetaData<T, Q> {
  data: {
    count: number;
    next: string | null;
    previous: string | null;
    results: T[];
    sections?: Q;
    summary?: Q;
    revenue_summary?: Q;
    category_counts?: Q;
    categories?: Record<string, undefined>;
    total_count?: number;
  };
  status: number;
}
interface QueryData<T> {
  data: {
    count: number;
    next: string | null;
    previous: string | null;
    results: T[];
  };
  status: number;
  course_batch_counts?: any;
total_count?: number

}
export interface IndividualQuery<T> {
  data: T;
  status: number;
}

interface axiosGetProp {
  limit?: number;
  offset?: number;
  search?: string;
  university?: string;
}
interface axiosCallProp {
  params?: axiosGetProp | any;
  endpoint: string;
  method?: any;
  id?: number | string | undefined;
  body?: any;
}

enum METHODS {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  PATCH = "PATCH",
  DELETE = "DELETE",
}

interface endpointProp {
  [key: string]: string | object | any;
}

interface SelectProps {
  label: string | number;
  value: string | number;
}

interface ColumnType<T> {
  name: React.ReactNode;
  width?: number | string;
  cell: (row: T) => React.ReactNode;
  sortable?: boolean;
}

export { METHODS };
export type {
  axiosGetProp,
  axiosCallProp,
  endpointProp,
  SelectProps,
  QueryData,
  QueryMetaData,
  ColumnType,
};
